var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95 5.998c0 .134-.02.259-.063.375a.872.872 0 01-.212.325L2.05 11.323a.891.891 0 01-.688.262.975.975 0 01-.687-.287.948.948 0 01-.275-.7c0-.283.092-.516.275-.7l3.9-3.9L.65 2.073a.894.894 0 01-.263-.688.978.978 0 01.288-.687.948.948 0 01.7-.275c.284 0 .517.092.7.275l4.6 4.6c.1.1.17.209.212.325.042.117.063.242.063.375z",
    fill: "#A8A9AC"
  })));
}

export default SvgIconRightArrow;